<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import Noty from 'noty'
  import store from '@/lib/store'

  const { mapState, mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    data () {
      return {
        user: store.get('user'),
        team: store.get('team')
      }
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      isCallEnded () {
        return ['completed', 'busy', 'failed', 'canceled', 'no-answer'].includes(this.activity.status)
      }
    },
    watch: {
      'activity.status': function () {
        this.hideWeAreCallingYouNotification()

        if (this.isCallEnded) {
          this.exitCallScreen()
        }
      }
    },
    created () {
      this.channel.bind('pusher:subscription_succeeded', this.fetchActivity)
      this.channel.bind('activity.status-updated', this.fetchActivity)
    },
    methods: {
      ...mapActions([
        'fetchActivity',
        'exitCallScreen'
      ]),
      hideWeAreCallingYouNotification () {
        Noty.closeAll('passthru-advice')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// activity-status-updated.vue?daf75dd4